// extracted by mini-css-extract-plugin
export default {"main_container":"StartingPageContent_main_container__72ITD"};